import lgs1 from "../assets/lgs1.jpeg";
import lgs2 from "../assets/lgs2.jpeg";
import lgs3 from "../assets/lgs3.jpeg";
import proofing1 from "../assets/proofing1.jpeg";
import roofing1 from "../assets/roofing1.jpeg";
import roofing2 from "../assets/roofing2.jpeg";
import terrazzo1 from "../assets/terrazzo1.jpeg";
import terrazzo2 from "../assets/terrazzo2.jpeg";
import terrazzo3 from "../assets/terrazzo3.jpeg";

export const PRODUCT_CATALOG = [
  {
    slug: "light-gauge-steel",
    title: "Light Gauge Steel (LGS)",
    shortTitle: "Light Gauge Steel",
    images: [lgs1, lgs2, lgs3],
    tagline: "Build Faster, Stronger, Smarter",
    overview:
      "Light Gauge Steel provides a modern, efficient framework that keeps construction projects on schedule, reduces material waste and lowers labor costs. Its lightweight yet high-strength steel components enable faster, more predictable installation compared to conventional timber or concrete systems. Resistant to pests, moisture, fire and rot, LGS ensures long-term structural reliability with minimal maintenance. Fully recyclable, it supports sustainable and environmentally responsible construction practices.",
    features: [
      "Roof trusses and purlins",
      "Wall frames and internal partitions",
      "Floor joists and ceiling systems",
      "External facades and cladding",
      "Custom or specialized structural solutions",
    ],
    advantages: [
      "High strength-to-weight ratio",
      "Faster builds with predictable timelines",
      "Precision-engineered components reducing onsite errors",
      "Adaptable to complex or customized layouts",
      "Corrosion-resistant and long-lasting",
      "Low maintenance lifecycle performance",
    ],
    idealFor:
      "Vertical and horizontal extensions, modular builds, prefabricated structures, and remote site developments including eco-lodges, elevated platforms and environmentally sensitive projects. Off-site fabrication and lightweight components make LGS especially effective in protected or difficult-to-access locations.",
    idealForDetails: {
      left:
        "Highly adaptable, LGS is ideal for vertical and horizontal extensions, modular builds and prefabricated structures, allowing seamless integration with existing buildings and enabling custom layouts and expansions without compromising structural integrity.",
      right:
        "Its lightweight components and off-site fabrication make it particularly effective in remote or environmentally sensitive locations such as game reserves, national parks and protected sites, where eco-lodges, elevated platforms, modular units and support facilities can be delivered efficiently with reduced environmental impact.",
    },
    cta: "Request a Free Consultation",
  },

  {
    slug: "waterproofing-solutions",
    title: "Waterproofing Solutions",
    shortTitle: "Waterproofing",
    images: [proofing1, roofing1, roofing2],
    tagline: "Protect Structures. Preserve Value.",
    overview:
      "Advanced waterproofing systems engineered to prevent leakage, seepage and structural water damage. Designed for both new construction and remedial works, our solutions enhance durability, structural integrity and lifecycle performance in high-moisture and exposed environments.",
    features: [
      "Roofs and roof decks",
      "Foundations and basements",
      "Bathrooms and wet areas",
      "Swimming pools and water-retaining structures",
      "Retaining walls and exposed concrete surfaces",
    ],
    advantages: [
      "High-performance moisture barrier systems",
      "Reliable protection in harsh weather conditions",
      "Long-term durability and lifecycle value",
      "Reduced maintenance and repair costs",
      "Suitable for new builds and refurbishment projects",
    ],
    idealFor:
      "Residential, commercial and industrial buildings requiring long-term protection against water ingress, particularly in high rainfall or high-humidity environments.",
    idealForDetails: {
      left:
        "Ideal for building owners and developers looking to ensure long-term protection against water damage and leakage.",
      right:
        "Applicable across residential, commercial, and industrial projects, including basements, roofs, bathrooms, and pools, with reliable performance in extreme conditions.",
    },
    cta: "Request a Free Consultation",
  },

  {
    slug: "terrazzo-flooring",
    title: "Terrazzo Flooring Solutions",
    shortTitle: "Terrazzo Flooring",
    images: [terrazzo1, terrazzo2, terrazzo3],
    tagline: "Architectural Finish. Engineered Durability.",
    overview:
      "Premium terrazzo flooring systems designed for high-traffic environments where aesthetics and durability are equally critical. Combining decorative aggregates with advanced binding systems, terrazzo delivers a seamless, polished architectural finish with exceptional wear resistance.",
    features: [
      "Residential properties",
      "Office and corporate spaces",
      "Schools and educational facilities",
      "Hospitals and healthcare environments",
      "Retail and public buildings",
    ],
    advantages: [
      "Custom color and aggregate combinations",
      "Seamless polished architectural finish",
      "High resistance to wear and heavy foot traffic",
      "Long service life with minimal maintenance",
      "Cost-effective alternative to natural stone",
    ],
    idealFor:
      "High-traffic commercial and institutional spaces requiring long-lasting, low-maintenance flooring with design flexibility and premium visual appeal.",
    idealForDetails: {
      left:
        "Ideal for spaces where both durability and aesthetics are critical, such as schools, hospitals, and offices.",
      right:
        "Terrazzo’s custom aggregates and binding systems allow a premium finish with long-lasting performance and minimal maintenance.",
    },
    cta: "Request a Free Consultation",
  },
];

// Map for easy lookup
export const PRODUCT_MAP = PRODUCT_CATALOG.reduce((acc, product) => {
  acc[product.slug] = product;
  return acc;
}, {});